import { User } from 'lucide-react';
import type { Message } from '@/lib/agents/types';
import { formatTime } from '@/lib/utils';

interface Props {
  message: Message;
}

export function UserMessage({ message }: Props) {
  const text = message.parts
    .filter((p) => p.type === 'text')
    .map((p) => (p as { type: 'text'; text: string }).text)
    .join('\n\n');

  return (
    <article className="group relative animate-fade-in py-3">
      <header className="mb-1.5 flex items-center gap-2 text-[12px] text-fg-subtle">
        <span className="flex h-5 w-5 items-center justify-center rounded-full bg-fg/10 text-fg-muted">
          <User className="h-3 w-3" />
        </span>
        <span className="font-medium text-fg">You</span>
        <span className="ml-auto tabular-nums">{formatTime(message.createdAt)}</span>
      </header>
      <div className="whitespace-pre-wrap text-[14px] leading-relaxed text-fg">
        {text}
      </div>
    </article>
  );
}
